"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizableError = exports.LocalizedError = void 0;
/**
 * Use this class if you are already translating your errors.
 */
class LocalizedError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        // have to set error prototype explicitly according to
        // https://stackoverflow.com/questions/31626231/custom-error-class-in-typescript
        Object.setPrototypeOf(this, LocalizedError.prototype);
    }
}
exports.LocalizedError = LocalizedError;
/**
 * Use this error class if you want to rely on a middleware to
 * translate your errors for you.  Useful if you do not want to pass
 * i18nNext around.
 */
class LocalizableError extends Error {
    constructor(status, key, parameters) {
        super(key);
        this.status = status;
        this.key = key;
        this.parameters = parameters;
    }
}
exports.LocalizableError = LocalizableError;
